export const toLocaleString = (amount = '0'): string => {
  return parseFloat(amount) && Number(parseFloat(amount).toLocaleString('en-US'))
    ? parseFloat(amount).toLocaleString('en-US')
    : String(amount || 0)
}
